export interface DrawConfig {
    html: string;
    keys?: Array<{
        key: string;
        hover: string;
        normal: string;
    }>;
    zoom?: number;
    size: {
        width: number;
        height: number;
    };
}
class Draw {
    dpr: number;
    success: Function;
    canvas: HTMLCanvasElement;
    context: CanvasRenderingContext2D;
    config: DrawConfig;
    total: number;
    constructor() {
        this.total = 0;
        this.dpr = window.devicePixelRatio || 1;
        this.canvas = document.createElement('canvas');
        this.context = this.canvas.getContext('2d');
        this.config = {
            html: '',
            zoom: 2,
            size: {
                width: 0,
                height: 0
            }
        };
    }
    cutting(vo: {
        key: string;
        hover: string;
        normal: string;
    }, key: string, img: HTMLImageElement, sx: number, sy: number, swidth: number, sheight: number, x: number, y: number, width: number, height: number) {
        const cw: number = width * this.dpr;
        const ch: number = height * this.dpr;
        this.canvas.width = cw;
        this.canvas.height = ch;
        this.canvas.style.cssText = `width:${width}px;height:${height}px`;
        // 画布清除
        this.context.clearRect(0, 0, cw, ch);
        this.context.drawImage(img, sx, sy, swidth, sheight, x, y, cw, ch);
        this.canvas.toBlob(blob => {
            this.total--;
            vo[key] = window.URL.createObjectURL(blob);
            // const img: HTMLImageElement = new Image();
            // img.src = window.URL.createObjectURL(blob);
            // vo[key] = img.src;
            // img.style.cssText = img.style.cssText = `position: absolute;z-index: 999;top: 0;`;
            // document.body.appendChild(img);
            if (this.total <= 0) {
                this.success();
            }
        });
    }
    svgToimg(config: DrawConfig, success: Function): DrawConfig {
        this.config = Object.assign(this.config, config);
        this.success = success;
        const { width, height } = this.config.size;
        const data = `<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}">${this.config.html}</svg>`;
        const url: string = window.URL.createObjectURL(new Blob([data], { type: 'image/svg+xml;charset=utf-8' }));
        const img: HTMLImageElement = new Image();
        this.total = this.config.keys.length * 2;
        img.onload = () => {
            this.config.keys.forEach((vo: {
                key: string;
                hover: string;
                normal: string;
            }, i: number) => {
                for (let k = 0; k < 2; k++) {
                    const key: string = k === 1 ? 'hover' : 'normal';
                    this.cutting(vo, key, img, i * 70, k * 70, 70, 70, 0, 0, 70, 70);
                }
            });
            // img.style.cssText = 'position: absolute;z-index: 999;top: 0;';
            window.URL.revokeObjectURL(url);
        };
        img.src = url;
        return this.config;
        // document.body.appendChild(img);
    }

}
export default new Draw();
